import "react-tooltip/dist/react-tooltip.css"
import "./src/css/normalize.css"
import "./src/css/style.css"
import "./src/css/modals.scss"
import "./src/css/lightboxes.scss"
import "./src/css/typography.css"
import "./src/css/colours.scss"
import "./src/css/animations.scss"

export const onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined" && location.hash) {
    setTimeout(() => {
      const element = document.querySelector(location.hash)
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    }, 0)
  }
}
